"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Price_Price
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_namespaceObject = require("@pcln/horizon");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
require("react");
const PricelineLogo_js_namespaceObject = require("../../../../svgs/PricelineLogo.js");
var PricelineLogo_js_default = /*#__PURE__*/ __webpack_require__.n(PricelineLogo_js_namespaceObject);
const VipLogo_js_namespaceObject = require("../../../../svgs/VipLogo.js");
var VipLogo_js_default = /*#__PURE__*/ __webpack_require__.n(VipLogo_js_namespaceObject);
const external_HotlListingCard_styles_js_namespaceObject = require("../../HotlListingCard.styles.js");
const external_getPriceUtils_js_namespaceObject = require("./getPriceUtils.js");
const Price = ({ propertyName, price, totalPrice, currency, savingsPct, priceDisplayRegulation, nightlyRateIncludingTaxesAndFees, nightlyRateExcludingTaxesAndFees, grandTotalExcludingTax, grandTotalSavingsPctExcludingTax, grandTotalStrikeThroughPrice, grandTotalStrikeThroughPriceExcludingTax, nightlyAllRoomsPriceExcludingTax, isPricingVariant })=>{
    let parsedStrikePrice = 0;
    let parsedNightlyRate = 0;
    let parsedTotalPrice = 0;
    const nightlyRate = (0, external_getPriceUtils_js_namespaceObject.getNightlyRate)({
        priceDisplayRegulation,
        nightlyAllRoomsPriceExcludingTax,
        nightlyRateIncludingTaxesAndFees,
        nightlyRateExcludingTaxesAndFees,
        price
    });
    const resolvedStrikePrice = (0, external_getPriceUtils_js_namespaceObject.getStrikePrice)({
        priceDisplayRegulation,
        grandTotalStrikeThroughPriceExcludingTax,
        grandTotalStrikeThroughPrice
    });
    const resolvedTotalPrice = (0, external_getPriceUtils_js_namespaceObject.getTotalPrice)({
        priceDisplayRegulation,
        grandTotalExcludingTax,
        totalPrice
    });
    const resolvedSavingsPct = (0, external_getPriceUtils_js_namespaceObject.getSavingsPct)({
        priceDisplayRegulation,
        grandTotalSavingsPctExcludingTax,
        savingsPct
    });
    if (!isNaN(Number(resolvedStrikePrice))) parsedStrikePrice = Math.round(parseInt(resolvedStrikePrice));
    if (!isNaN(Number(nightlyRate))) parsedNightlyRate = Math.round(parseInt(nightlyRate));
    if (!isNaN(Number(resolvedTotalPrice))) parsedTotalPrice = Math.round(parseInt(resolvedTotalPrice));
    if (isPricingVariant) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex w-full items-center justify-between",
        "aria-label": `Price and Merchandizing information for ${propertyName}`,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("section", {
                className: "w-2/3",
                "aria-label": `Merchandizing information for ${propertyName}`,
                children: resolvedSavingsPct ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "flex flex-row items-start",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: "flex items-center justify-center gap-1 leading-6",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: "mt-2 flex h-5",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(PricelineLogo_js_default(), {
                                            width: '60px',
                                            height: '24px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VipLogo_js_default(), {
                                            width: '24px',
                                            height: '24px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(horizon_namespaceObject.P, {
                                        className: "text-priceRetail-11 text-heading5 flex leading-6",
                                        children: [
                                            parseInt(resolvedSavingsPct, 10),
                                            "% Off"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.P, {
                            className: "text-neutral-10 text-body3 flex",
                            children: "Lower price because you're a VIP!"
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("section", {
                className: "text-priceRetail-13 flex flex-col",
                "aria-label": `Price information for ${propertyName}`,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(horizon_namespaceObject.P, {
                        className: "text-body3 flex items-center justify-end font-light",
                        children: [
                            "Per night ",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("sup", {
                                className: "ml-1",
                                children: currency
                            }),
                            " ",
                            parsedNightlyRate
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: "flex items-center justify-end",
                        children: [
                            parsedStrikePrice > 0 ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: "text-urgency-8 text-body3 relative mr-1",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("sup", {
                                        children: currency
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                        className: 'before:border-urgency-8 before:border-b-1 before:absolute before:left-1.5 before:top-1/2 before:block before:h-px before:w-4/5 before:rotate-[-15deg] before:content-[""]',
                                        children: parsedStrikePrice
                                    })
                                ]
                            }) : null,
                            parsedTotalPrice ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("span", {
                                className: "font-bold leading-5",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("sup", {
                                        className: "text-priceSuper-heading4",
                                        children: currency
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                        className: "text-heading4",
                                        children: parsedTotalPrice
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                        className: "text-priceSale-10 text-body3",
                        children: "2 nights, 1 room"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 1,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                width: '65%',
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                    width: 1,
                    children: resolvedSavingsPct ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                alignItems: "center",
                                "data-testid": "PENNY_PCLN_VIPICON",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        pr: 2,
                                        top: '3px',
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(PricelineLogo_js_default(), {
                                            width: '60px',
                                            height: '20px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VipLogo_js_default(), {
                                            width: '24px',
                                            height: '24px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        top: '-3px',
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                            color: 'pricePrimary.base',
                                            lineHeight: '22px',
                                            ml: 1,
                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
                                                fontSize: 2,
                                                fontWeight: "bold",
                                                children: [
                                                    parseInt(resolvedSavingsPct, 10),
                                                    "% Off"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                    fontSize: 0,
                                    color: 'text.light',
                                    children: "Lower price because you're a VIP!"
                                })
                            })
                        ]
                    }) : null
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                textAlign: 'right',
                children: [
                    parsedStrikePrice > 0 ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_HotlListingCard_styles_js_namespaceObject.TextStrikeThrough, {
                            lineHeight: '22px',
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotlListingCard_styles_js_namespaceObject.PriceCurrencyStrikeThrough, {
                                    fontSize: '8px',
                                    fontWeight: "bold",
                                    children: currency
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                    fontSize: 1,
                                    fontWeight: "bold",
                                    children: parsedStrikePrice
                                })
                            ]
                        })
                    }) : null,
                    parsedNightlyRate ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                        color: 'pricePrimary.base',
                        lineHeight: '22px',
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotlListingCard_styles_js_namespaceObject.PriceCurrency, {
                                fontSize: 0,
                                fontWeight: "bold",
                                children: currency
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                fontSize: 4,
                                fontWeight: "bold",
                                children: parsedNightlyRate
                            })
                        ]
                    }) : null,
                    parsedTotalPrice ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                        fontSize: 0,
                        lineHeight: '16px',
                        color: 'text.light',
                        children: [
                            "Total: ",
                            currency,
                            parsedTotalPrice
                        ]
                    }) : null
                ]
            })
        ]
    });
};
const Price_Price = Price;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
